import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MicrosoftCallbackComponent} from './auth/microsoft-callback/microsoft-callback.component';
import {LinkLoginComponent} from './auth/link-login/link-login.component';
import {IsNotAuthenticated} from './is-not-authenticated';
import {LogoutComponent} from './logout/logout.component';
import {AppRoute} from './interfaces/app-route.interface';
import {IsAuthenticated} from './is-authenticated';
import {PlatformEditComponent} from './platform/platform-edit.component';
import {CompanyEditComponent} from './companies/edit/company-edit.component';
import {CompaniesComponent} from './companies/companies.component';
import {UsersOverviewComponent} from './users/users-overview/users-overview.component';
import {UserEditComponent} from './users/user-edit/user-edit.component';
import {RightsManagementComponent} from './rights-management/rights-management.component';
import {CheckpointOverviewComponent} from './checkpoints/checkpoint-overview.component';
import {CheckpointStoreComponent} from './checkpoints/store/checkpoint-store.component';
import {SeireComponent} from './seire/seire.component';
import {PlatformCheckpointsComponent} from './seire/platform-checkpoints/platform-checkpoints.component';
import {CheckpointResultOverviewComponent} from './checkpoints/checkpoint-result-overview/checkpoint-result-overview.component';
import {RegistrationComponent} from './time-registration/registration.component';
import {DailyComponent} from './daily/daily.component';
import {SubscriptionEditComponent} from './subscriptions/subscription-edit/subscription-edit.component';
import {SubscriptionsComponent} from './subscriptions/subscriptions.component';
import {FinancialComponent} from './financial/financial.component';
import {ReportComponent} from './report/report.component';
import {PdfBriefpapierComponent} from './pdf-briefpapier/pdf-briefpapier.component';
import {Routenames} from './classes/route-name.enum';
import {LeaveComponent} from './leave/leave.component';
import {LeaveEditComponent} from './leave/leave-edit/leave-edit.component';
import {WeeklyComponent} from './weekly/weekly.component';
import {ProfileComponent} from './profile/profile.component';

export const routes: AppRoute[] = [
    {path: '', redirectTo: `${Routenames.seire}`, pathMatch: 'full'},
    {path: 'platforms', redirectTo: `${Routenames.seire}`, pathMatch: 'full'},

    {path: 'login', component: LinkLoginComponent, canActivate: [IsNotAuthenticated]},
    {
        path: 'inloggen/entra',
        component: MicrosoftCallbackComponent
    },
    {path: 'print/:date/:token', component: LinkLoginComponent},
    {path: `${Routenames.logout}`, component: LogoutComponent},

    {path: `${Routenames.seire}`, component: SeireComponent, canActivate: [IsAuthenticated]},
    {
        path: `${Routenames.seire}/:platformId`,
        component: PlatformCheckpointsComponent,
        canActivate: [IsAuthenticated]
    },
    {
        path: `${Routenames.seire}/:platformId/overview/:checkId`,
        component: CheckpointOverviewComponent,
        canActivate: [IsAuthenticated]
    },
    {
        path: `${Routenames.seire}/:platformId/store/:checkId`,
        component: CheckpointStoreComponent,
        canActivate: [IsAuthenticated]
    },
    {
        path: `${Routenames.seire}/:platformId/overview/:checkId/:checkResultId`,
        component: CheckpointResultOverviewComponent,
        canActivate: [IsAuthenticated]
    },

    {path: `${Routenames.companies}`, component: CompaniesComponent, canActivate: [IsAuthenticated]},
    {path: `${Routenames.companies}/:id`, component: CompanyEditComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.users}`, component: UsersOverviewComponent, canActivate: [IsAuthenticated]},
    {path: `${Routenames.users}/:id`, component: UserEditComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.platforms}/:id`, component: PlatformEditComponent, canActivate: [IsAuthenticated]},

    {
        path: `${Routenames.rightsMatrix}`,
        component: RightsManagementComponent,
        canActivate: [IsAuthenticated],
        data: {
            // requiredFunctionality: Functionalities.RightsMatrix,
        }
    },
    {path: `${Routenames.registration}`, component: RegistrationComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.leave}`, component: LeaveComponent, canActivate: [IsAuthenticated]},
    {path: `${Routenames.leave}/:id`, component: LeaveEditComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.reports}`, component: ReportComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.pdf}/${Routenames.underlay}`, component: PdfBriefpapierComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.daily}`, component: DailyComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.weekly}`, component: WeeklyComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.profile}`, component: ProfileComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.subscriptions}`, component: SubscriptionsComponent, canActivate: [IsAuthenticated]},
    {path: `${Routenames.subscriptions}/:id`, component: SubscriptionEditComponent, canActivate: [IsAuthenticated]},

    {path: `${Routenames.financials}`, component: FinancialComponent, canActivate: [IsAuthenticated]},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
    providers: [IsAuthenticated, IsNotAuthenticated]
})
export class AppRoutingModule {
}
